// import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
// import api from '../components/Api';
// import { useNavigate } from 'react-router-dom';
// import {toast } from 'react-toastify';
// const AppContext = createContext();
// export const useAppContext = () => useContext(AppContext);

// export const AppProvider = ({ children }) => {
//   const [authState, setAuthState] = useState({
//     isAuth: false,
//       isLoading: true,
//     user: null,
//   });

//   const [loading, setLoading] = useState(true);
//   const [showWarning, setShowWarning] = useState(false);
//   const navigate = useNavigate();

//   const logoutTimerRef = useRef(null);
//   const warningTimerRef = useRef(null);

//   const AUTO_LOGOUT_MS =1800000 * 1000; // 10s test
//   const WARNING_BEFORE_MS =300000 * 1000; // show warning 5s before logout

//   // 🔄 Initialize auth on app load
// useEffect(() => {
//   const initAuth = async () => {
//     try {
//       const res = await api.post('/auth/refresh');

//       localStorage.setItem('accessToken', res.data.accessToken);

//       setAuthState({
//         isAuth: true,
//           isLoading: false,
//         user: res.data.user || null,
//       });

//       startAutoLogoutTimer();
//     } catch (err) {
//          console.log('REFRESH FAILED', err.response?.status);
//       localStorage.removeItem('accessToken');
//       setAuthState({ isAuth: false,   isLoading: false, user: null });
//     } finally {
     
//     }
//   };

//   initAuth();

//   const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
//   const resetTimer = () => {
//     if (authState.isAuth) startAutoLogoutTimer();
//   };

//   events.forEach(e => window.addEventListener(e, resetTimer));

//   return () => {
//     events.forEach(e => window.removeEventListener(e, resetTimer));
//     clearTimers();
//   };
// }, []); // ✅ RUN ONCE



//   const login = async (username, password) => {
//   try {
//     const res = await api.post('/auth/login', { username, password });

//     console.log(res.data?.accessToken)
//     if (res.data?.accessToken) {
//       localStorage.setItem('accessToken', res.data.accessToken);
//       setAuthState({
//         isAuth: true,
//         user: res.data.user || null,
//       });

//       startAutoLogoutTimer();
//       return { stat: true };
//     }

//     return {
//       stat: false,
//       message: res.data?.message || 'Invalid credentials',
//     };

//   } catch (error) {
//     // Server down / network error / timeout
//     return {
//       stat: false,
//       message:
//         error?.response?.data?.message ||
//         'Server is unreachable. Please try again later.',
//     };
//   }
// };



//   const logout = async () => {

//     clearTimers();
//     try {
//       await api.post('/auth/logout');
//     } catch (err) {
    
//     }

//     localStorage.removeItem('accessToken');
//     setAuthState({ isAuth: false, user: null });
//     setShowWarning(false);
//     navigate('/');
//   };

//   const clearTimers = () => {
//     if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
//     if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
//   };

//   const startAutoLogoutTimer = () => {
//     clearTimers();
//     setShowWarning(false);

//     // Show warning a few seconds before actual logout
//     warningTimerRef.current = setTimeout(() => {
//       setShowWarning(true);
//     }, AUTO_LOGOUT_MS - WARNING_BEFORE_MS);

//     logoutTimerRef.current = setTimeout(() => {
//       logout();
//     }, AUTO_LOGOUT_MS);
//   };

//   const stayLoggedIn = () => {
//     startAutoLogoutTimer();
//   };

//   return (
//     <AppContext.Provider value={{ authState, login, logout }}>


//           {children}
//           {showWarning && (
// <>
//             <div
//   style={{
//     position: 'fixed',
//     inset: 0,
//     background: 'rgba(0,0,0,0.35)',
//     zIndex: 9998
//   }}
// />
//            <div
//   style={{
//     position: 'fixed',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     padding: '15px',
//     background: 'orange',
//     color: 'white',
//     borderRadius: '5px',
//     zIndex: 9999
//   }}
// >
//   <p>You will be logged out soon due to inactivity.</p>

//   <button
//     onClick={stayLoggedIn}
//     style={{ padding: '5px 10px', cursor: 'pointer' }}
//   >
//     Stay Logged In
//   </button>
// </div>
//   </>   
   
//       )}
    
//     </AppContext.Provider>
//   );
// };





import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import api from '../components/Api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuth: false,
    isLoading: true,
    user: null,
  });
  const [showWarning, setShowWarning] = useState(false);

  const logoutTimerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const authRef = useRef(authState); 
  const eventSourceRef = useRef(null);

  const navigate = useNavigate();

  // Auto logout / warning timers (in ms)
  const AUTO_LOGOUT_MS = 800* 1000; // 10s test
  const WARNING_BEFORE_MS = 100 * 1000; // 5s before logout

  // Keep authRef updated
  useEffect(() => {
    authRef.current = authState;
  }, [authState]);

  // Initialize auth on app load
  useEffect(() => {
    const initAuth = async () => {
      try {
        const res = await api.post('/auth/refresh');
        const token = res.data.accessToken;
console.log(token);
        localStorage.setItem('accessToken', token);
        setAuthState({
          isAuth: true,
          isLoading: false,
          user: res.data.user || null,
        });

        startAutoLogoutTimer();
        initSSE(token); // connect SSE after we have token
      } catch (err) {
        console.log('REFRESH FAILED', err.response?.status);
        localStorage.removeItem('accessToken');
        setAuthState({ isAuth: false, isLoading: false, user: null });
      }
    };

    initAuth();

    // Activity listeners
    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    const resetTimer = () => {
      if (authRef.current.isAuth) startAutoLogoutTimer();
    };
    events.forEach(e => window.addEventListener(e, resetTimer));

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      clearTimers();
      if (eventSourceRef.current) eventSourceRef.current.close();
    };
  }, []);

  // ------------------------
  // SSE connection
  // ------------------------
  const initSSE = (token) => {
    if (!token) return;

    if (eventSourceRef.current) eventSourceRef.current.close();

    const encodedToken = encodeURIComponent(token);
    const es = new EventSource(`http://localhost:5009/sse/events?token=${encodedToken}`);

    es.onopen = () => console.log('SSE connected');
    es.onerror = (err) => console.error('SSE error', err);
    es.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log('SSE Event:', data);
        // handle messages or notifications here
      } catch (err) {
        console.error('Invalid SSE data', err);
      }
    };

    eventSourceRef.current = es;
  };

  // ------------------------
  // login
  // ------------------------
  const login = async (username, password) => {
    try {
      const res = await api.post('/auth/login', { username, password });
      const token = res.data.accessToken;

      if (!token) return { stat: false, message: 'Invalid credentials' };

      localStorage.setItem('accessToken', token);
      setAuthState({
        isAuth: true,
        user: res.data.user || null,
      });
      startAutoLogoutTimer();
      initSSE(token);
      return { stat: true };
    } catch (err) {
      return { stat: false, message: err?.response?.data?.message || 'Server unreachable' };
    }
  };

  // ------------------------
  // logout
  // ------------------------
  const logout = async () => {
    clearTimers();
    try {
      await api.post('/auth/logout');
    } catch (err) {}

    localStorage.removeItem('accessToken');
    setAuthState({ isAuth: false, user: null });
    setShowWarning(false);
    navigate('/');
  };

  const clearTimers = () => {
    if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
  };

  const startAutoLogoutTimer = () => {
    clearTimers();
    setShowWarning(false);

    warningTimerRef.current = setTimeout(() => {
      setShowWarning(true);
    }, AUTO_LOGOUT_MS - WARNING_BEFORE_MS);

    logoutTimerRef.current = setTimeout(() => {
      logout();
    }, AUTO_LOGOUT_MS);
  };

  const stayLoggedIn = () => {
    startAutoLogoutTimer();
  };

  return (
    <AppContext.Provider value={{ authState, login, logout }}>
      {children}
      {showWarning && (
        <>
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 9998 }} />
          <div style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            padding: '15px',
            background: 'orange',
            color: 'white',
            borderRadius: '5px',
            zIndex: 9999
          }}>
            <p>You will be logged out soon due to inactivity.</p>
            <button onClick={stayLoggedIn} style={{ padding: '5px 10px', cursor: 'pointer' }}>Stay Logged In</button>
          </div>
        </>
      )}
    </AppContext.Provider>
  );
};